module.exports = __webpack_public_path__ + "static/media/home.51b00f39.svg";